var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "native-button-tabs" },
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "div",
          {
            key: tab.id,
            staticClass: "tab-list",
            class: { active: tab.id === _vm.tabActive },
            on: {
              click: function($event) {
                _vm.tabActive = tab.id
              }
            }
          },
          [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")]
        )
      })
    ),
    _vm._v(" "),
    _vm.tabActive === "non-workflow"
      ? _c("div", { staticClass: "native-buttons" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _vm.menu === "create"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "create"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-blue" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.create &&
                                _vm.dataButtons.create.label
                                ? _vm.dataButtons.create.label
                                : "Create"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "create", "Create")
                          }
                        }
                      },
                      [_vm._m(0)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "detail"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "update"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-blue" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.update &&
                                _vm.dataButtons.update.label
                                ? _vm.dataButtons.update.label
                                : "Update"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "update", "Update")
                          }
                        }
                      },
                      [_vm._m(1)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isPageScreen
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "delete"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-red" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.delete &&
                                _vm.dataButtons.delete.label
                                ? _vm.dataButtons.delete.label
                                : "Delete"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "delete", "Delete")
                          }
                        }
                      },
                      [_vm._m(2)]
                    )
                  ]
                )
              : _c("div", { staticClass: "wrap-button" }, [_vm._m(3)])
          ]),
          _vm._v(" "),
          !_vm.isPageScreen && _vm.menu === "detail"
            ? _c(
                "div",
                {
                  staticClass: "wrap-button",
                  class: { "wrap-button-active": _vm.buttonActive === "delete" }
                },
                [
                  _c("button", { staticClass: "button-red" }, [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.dataButtons.delete &&
                              _vm.dataButtons.delete.label
                              ? _vm.dataButtons.delete.label
                              : "Delete"
                          ) +
                          "\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "edit",
                      on: {
                        click: function($event) {
                          _vm.$emit("select-btn", "delete", "Delete")
                        }
                      }
                    },
                    [_vm._m(4)]
                  )
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tabActive === "requester"
      ? _c("div", { staticClass: "native-buttons" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _vm.menu === "create"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "draft"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-blue" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.draft &&
                                _vm.dataButtons.draft.label
                                ? _vm.dataButtons.draft.label
                                : "Save to Draft"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "draft", "Save to Draft")
                          }
                        }
                      },
                      [_vm._m(5)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "create"
              ? _c("div", { staticClass: "wrap-button" }, [_vm._m(6)])
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "detail" && !_vm.isMultiple
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "update"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-gray" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.update &&
                                _vm.dataButtons.update.label
                                ? _vm.dataButtons.update.label
                                : "Update to Draft"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "update", "Update to Draft")
                          }
                        }
                      },
                      [_vm._m(7)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "detail"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "submit"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-blue" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.submit &&
                                _vm.dataButtons.submit.label
                                ? _vm.dataButtons.submit.label
                                : "Submit"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "submit", "Submit")
                          }
                        }
                      },
                      [_vm._m(8)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "detail"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "close"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-green" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.close &&
                                _vm.dataButtons.close.label
                                ? _vm.dataButtons.close.label
                                : "Close"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "close", "Close")
                          }
                        }
                      },
                      [_vm._m(9)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menu === "detail"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "cancel"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-brown" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.cancel &&
                                _vm.dataButtons.cancel.label
                                ? _vm.dataButtons.cancel.label
                                : "Cancel"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "cancel", "Cancel")
                          }
                        }
                      },
                      [_vm._m(10)]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _vm.menu === "detail"
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "delete"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-red" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.delete &&
                                _vm.dataButtons.delete.label
                                ? _vm.dataButtons.delete.label
                                : "Delete"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "delete", "Delete")
                          }
                        }
                      },
                      [_vm._m(11)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPageScreen && _vm.menu === "detail"
              ? _c("div", { staticClass: "wrap-button" }, [_vm._m(12)])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tabActive === "approver"
      ? _c("div", { staticClass: "native-buttons" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "div",
              {
                staticClass: "wrap-button",
                class: { "wrap-button-active": _vm.buttonActive === "approve" }
              },
              [
                _c("button", { staticClass: "button-blue" }, [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.dataButtons.approve &&
                            _vm.dataButtons.approve.label
                            ? _vm.dataButtons.approve.label
                            : "Approve"
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        _vm.$emit("select-btn", "approve", "Approve")
                      }
                    }
                  },
                  [_vm._m(13)]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrap-button",
                class: {
                  "wrap-button-active": _vm.buttonActive === "approveUpdate"
                }
              },
              [
                _c("button", { staticClass: "button-blue" }, [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.dataButtons.approveUpdate &&
                            _vm.dataButtons.approveUpdate.label
                            ? _vm.dataButtons.approveUpdate.label
                            : "Approve & Update"
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        _vm.$emit(
                          "select-btn",
                          "approveUpdate",
                          "Approve & Update"
                        )
                      }
                    }
                  },
                  [_vm._m(14)]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrap-button",
                class: { "wrap-button-active": _vm.buttonActive === "reject" }
              },
              [
                _c("button", { staticClass: "button-purple" }, [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.dataButtons.reject && _vm.dataButtons.reject.label
                            ? _vm.dataButtons.reject.label
                            : "Reject"
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        _vm.$emit("select-btn", "reject", "Reject")
                      }
                    }
                  },
                  [_vm._m(15)]
                )
              ]
            ),
            _vm._v(" "),
            _vm.isWorkflow &&
            _vm.isDynamicWorkflow &&
            _vm.isApproverSelectionByFunction
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-button",
                    class: {
                      "wrap-button-active": _vm.buttonActive === "revision"
                    }
                  },
                  [
                    _c("button", { staticClass: "button-gray" }, [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dataButtons.revision &&
                                _vm.dataButtons.revision.label
                                ? _vm.dataButtons.revision.label
                                : "Need Revision"
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            _vm.$emit("select-btn", "revision", "Need Revision")
                          }
                        }
                      },
                      [_vm._m(16)]
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "button-gray" }, [
      _c("span", [_vm._v("\n            Close\n          ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "button-gray" }, [
      _c("span", [_vm._v("\n            Close\n          ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "button-gray" }, [
      _c("span", [_vm._v("\n            Close\n          ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", [_c("i", { staticClass: "fa fa-pencil-square-o" })])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ae660d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae660d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/NativeButtons.vue
// module id = null
// module chunks = 